// Shared provider availability source for booking/profile/chatbot guidance.
// Update this file first when new-client booking availability changes, then run
// `npm run validate:provider-availability` to catch profile/chatbot drift.

export const providerAvailability = [
  {
    id: "jeika-matthew",
    name: "Jeika Matthew",
    acceptingNewClients: true,
    acceptingIndividualClients: true,
    acceptingCouplesClients: true,
    acceptingChildClients: false,
    acceptingTeenClients: true,
    acceptingAdultClients: true,
    acceptingGroupClients: false,
    serviceFormats: ["in-person", "telehealth"],
    currentAvailabilityFormats: ["in-person", "telehealth"],
    worksWith: ["Teens", "Adults", "Couples"],
    languages: ["English"],
    isSpanishSpeaking: false,
    availabilityNote: "Accepting individual and couples clients.",
    bookingVisibility: "visible",
    displayOrder: 4,
  },
  {
    id: "neyla-sassi",
    name: "Neyla Sassi",
    acceptingNewClients: true,
    acceptingIndividualClients: true,
    acceptingCouplesClients: false,
    acceptingChildClients: true,
    acceptingTeenClients: true,
    acceptingAdultClients: true,
    acceptingGroupClients: true,
    serviceFormats: ["in-person", "telehealth"],
    currentAvailabilityFormats: ["in-person", "telehealth"],
    worksWith: ["Children", "Teens", "Adults", "Groups"],
    languages: ["English"],
    isSpanishSpeaking: false,
    availabilityNote:
      "Accepting children, teens, adults, and groups; not accepting couples.",
    bookingVisibility: "visible",
    displayOrder: 1,
  },
  {
    id: "george-lopez",
    name: "George Lopez",
    acceptingNewClients: true,
    acceptingIndividualClients: true,
    acceptingCouplesClients: false,
    acceptingChildClients: true,
    acceptingTeenClients: true,
    acceptingAdultClients: true,
    acceptingGroupClients: true,
    serviceFormats: ["in-person", "telehealth"],
    currentAvailabilityFormats: ["in-person", "telehealth"],
    worksWith: ["Children", "Teens", "Adults", "Groups"],
    languages: ["English", "Spanish"],
    isSpanishSpeaking: true,
    availabilityNote:
      "Bilingual English/Spanish; accepting children, teens, adults, and groups in person and via telehealth.",
    bookingVisibility: "visible",
    displayOrder: 2,
  },
  {
    id: "jacqueline-suarez",
    name: "Jacqueline Suarez",
    acceptingNewClients: true,
    acceptingIndividualClients: true,
    acceptingCouplesClients: true,
    acceptingChildClients: false,
    acceptingTeenClients: true,
    acceptingAdultClients: true,
    acceptingGroupClients: true,
    serviceFormats: ["telehealth"],
    currentAvailabilityFormats: ["telehealth"],
    worksWith: ["Teens", "Adults", "Couples", "Groups"],
    languages: ["English", "Spanish"],
    isSpanishSpeaking: true,
    availabilityNote:
      "Bilingual English/Spanish; telehealth only; accepting individual, couples, and group clients.",
    bookingVisibility: "visible",
    displayOrder: 3,
  },
  {
    id: "maddie-lula",
    name: "Maddie Lula",
    acceptingNewClients: true,
    acceptingIndividualClients: true,
    acceptingCouplesClients: false,
    acceptingChildClients: true,
    acceptingTeenClients: true,
    acceptingAdultClients: true,
    acceptingGroupClients: true,
    serviceFormats: ["in-person", "telehealth"],
    currentAvailabilityFormats: ["in-person", "telehealth"],
    worksWith: ["Children", "Teens", "Adults", "Groups"],
    languages: ["English"],
    isSpanishSpeaking: false,
    availabilityNote:
      "Accepting children, teens, adults, and groups; in-person availability in Larchmont, NY and telehealth in New York.",
    bookingVisibility: "visible",
    displayOrder: 5,
  },
];

export const providerAvailabilityById = Object.fromEntries(
  providerAvailability.map((provider) => [provider.id, provider])
);
